import React from 'react'
import { InfoFuturePlannedStyle } from './info-future-planned-style'
import { InfoFuturePlannedView } from './info-future-planned-view'

export const InfoFuturePlannedContainer: React.FC<React.ComponentProps<typeof InfoFuturePlannedView>> = ({ ...rest }) => {
  return <InfoFuturePlannedStyle {...rest} />
}
